import { secondsToMilliseconds } from "@suse-o11y/date-time";
import { useCallback } from "react";

import { Type, type ViewType } from "~/models/dto";

import { DEFAULT_VIEW_TYPE } from "../hardcoded/view-types/DefaultViewType";

import { useQueryNodesList } from "./nodes";
import type { UseQueryResult } from "./react-query";

export const useGetViewTypeByIdentifier = (viewTypeIdentifier: undefined | string): UseQueryResult<ViewType, Error> =>
	useQueryNodesList(Type.ViewType, {
		select: useCallback(
			(viewTypes: Array<ViewType>) => {
				if (viewTypeIdentifier == null) {
					return DEFAULT_VIEW_TYPE;
				}

				return viewTypes.find(({ identifier }) => identifier === viewTypeIdentifier) ?? DEFAULT_VIEW_TYPE;
			},
			[viewTypeIdentifier],
		),

		// Allowing for stale data to avoid hitting the api multiple times in short time. This data doesn't change frequently.
		staleTime: secondsToMilliseconds(30),
		cacheTime: Number.POSITIVE_INFINITY,
	});
